import React, { useState, useEffect,useRef } from "react";
import { RouterConstant } from "../../routers/index";
import { useNavigate ,useLocation} from "react-router-dom";
import { useLayoutContext } from "../../layouts/general-layout";
import "./display-video.scss";
import { TrackingService } from  "../../services/tracking/tracking.service";
import { useUserStore } from "../../utils/userStore";
import { resetExericeStore } from "../../utils/utils";
import { chaserthumbnail , VideoPlay} from "../../assets/images/index";
import NextButton from "../../components/next-button";
import { UserService } from "../../services/user/user.service";


export default function Index() {
  const { t } = useLayoutContext();
  const navigate = useNavigate();
  const { ROUTERS_PATH } = RouterConstant;
  const [inputMessage, setInputMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [sessionId, setSessionId] = useState("");
  const trackingServiceInstance = new TrackingService();
  const userServiceInstance = new UserService();
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [displayControl, setDisplayControl] = useState(false);
  const [videoUrl, setVideoUrl] = useState<string>('');    
  const location = useLocation();
  const loginCount = location.state?.loginCount || 0;


  useEffect(() => {
      if (loginCount <= 1) {
        const url = import.meta.env.VITE_VIDEO_URL_1;
        setVideoUrl(url);      
      } else if (loginCount == 2) {
        const url = import.meta.env.VITE_VIDEO_URL_2;
        setVideoUrl(url);      
      }   
  }, []);



  const handlePlayButtonClick = () => {
    const videoElement = videoRef.current;
    if (videoElement) {
      // If src is already set (e.g., video was paused), just play.
      if (videoElement.currentSrc) {
        videoElement.play().catch(error => {
          if (error.name !== 'AbortError') {
            console.error("Error attempting to play video:", error);
          }
        });
        return;
      }

      // If the source isn't set, set it and wait for it to be playable.
      const onCanPlay = () => {
        videoElement.play().catch(error => {
          if (error.name !== 'AbortError') {
            console.error("Error playing video after canplay event:", error);
          }
        });
        // Clean up the event listener to avoid it firing again
        videoElement.removeEventListener('canplay', onCanPlay);
      };

      videoElement.addEventListener('canplay', onCanPlay);

      // Cache-busting: Append a unique timestamp to the URL. This forces the
      // browser to treat it as a new resource, bypassing any cache and preventing
      // it from sending the "Conditional headers" that Azure File Storage rejects.
      const cacheBustedUrl = `${videoUrl}&_cb=${new Date().getTime()}`;
      videoElement.src = cacheBustedUrl;
      videoElement.load(); // Explicitly tell the element to load the new source
      setIsPlaying(true);
      setDisplayControl(true);
    }
  };


  return (
    <div className="display-video-page full-head-template">
        <div className="display-video-body">
            <div className="video-player-container">
                <video        
                ref={videoRef}
                className="video-player"
                controls={displayControl}
                autoPlay={true}  
                preload="metadata" 
                poster={chaserthumbnail} 
                aria-label="נגן וידאו לתרגיל מתמטי"          
                onPlay={() => setIsPlaying(true)}
                onPause={() => setIsPlaying(false)}
                >
                הדפדפן שלך אינו תומך בנגן וידאו.
                </video>
                {!isPlaying && (
                    <div className="play-button-container" onClick={handlePlayButtonClick} aria-label="הפעל וידאו">            
                        <img src={VideoPlay} alt="Play Icon" className="play-icon-image" />            
                </div>  
                )}
        </div> 
            <div className="skip-button-container">
                <div>דלג</div>
                <NextButton link={ROUTERS_PATH.CHOOSEEXERCISE}/>
            </div>
        </div>
    </div>
  );
}